export const getActionVerb = (text: string): string[] => {
  const words = text.split(' ');
  const actionVerb = words.shift();
  /* eslint-disable @typescript-eslint/no-non-null-assertion */
  return [actionVerb!, words.join(' ')]; /* eslint-enable @typescript-eslint/no-non-null-assertion */
};
